<template>
    <header class="hero-header" dir="rtl">
        <!-- Overlay to close dropdowns -->
        <div
            v-if="showCategories || showUserMenu"
            class="dropdown-overlay"
            @click="showCategories = false; showUserMenu = false"
        ></div>

        <div class="hero-container">
            <!-- Right Section (RTL): Logo + Navigation + Geometric Shapes -->
            <div class="hero-right">
                <router-link to="/" class="hero-logo">
                    <img src="https://nashoof.sd.zain.com/assets/img/Nashoof.png" alt="Nashoof" />
                </router-link>

                <!-- Navigation Pills -->
                <nav class="hero-nav">
                    <router-link to="/" class="nav-pill">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>
                        </svg>
                        <span>الرئيسية</span>
                    </router-link>

                    <div class="nav-dropdown">
                        <button type="button" class="nav-pill" @click.stop="showCategories = !showCategories">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z"/>
                            </svg>
                            <span>التصنيفات</span>
                            <svg class="chevron" :class="{ 'rotate': showCategories }" width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"/>
                            </svg>
                        </button>
                        <div v-if="showCategories" class="dropdown-menu-box">
                            <router-link to="/Health" class="dropdown-link">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M19 3H5c-1.1 0-1.99.9-1.99 2L3 19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 11h-4v4h-4v-4H6v-4h4V6h4v4h4v4z"/>
                                </svg>
                                صحة
                            </router-link>
                            <router-link to="/Education" class="dropdown-link">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3L1 9l11 6 9-4.91V17h2V9L12 3z"/>
                                </svg>
                                تعليم
                            </router-link>
                            <router-link to="/Low" class="dropdown-link">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M4 4h16v2H4zm0 14h16v2H4zm0-7h16v2H4z"/>
                                </svg>
                                قانون
                            </router-link>
                            <router-link to="/Art" class="dropdown-link">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M18 4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4h-4z"/>
                                </svg>
                                فن ودراما
                            </router-link>
                        </div>
                    </div>
                </nav>
            </div>

            <!-- Center Section: Search Input -->
            <div class="hero-center">
                <form @submit.prevent="SearchData()" class="search-container">
                    <input
                        type="text"
                        v-model="search"
                        class="search-input"
                        placeholder="بحث عن المحتوى..."
                    />
                    <button type="submit" class="search-btn">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
                        </svg>
                    </button>
                </form>
            </div>

            <!-- Left Section (RTL): Zain Logo + Action Buttons -->
            <div class="hero-left">
                <!-- Action Buttons -->
                <div class="action-buttons">
                    <!-- User Menu (if logged in) -->
                    <div class="nav-dropdown" v-if="showHeader">
                        <button type="button" class="btn-pill btn-outline" @click.stop="showUserMenu = !showUserMenu">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
                            </svg>
                            <span>{{ $cookie.getCookie("mdn") }}</span>
                        </button>
                        <div v-if="showUserMenu" class="dropdown-menu-box">
                            <router-link to="/Profile" class="dropdown-link" @click="showUserMenu = false">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z"/>
                                </svg>
                                حسابي
                            </router-link>
                            <button class="dropdown-link unsub-link" @click="unsubscribe()">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z"/>
                                </svg>
                                الغاء الاشتراك
                            </button>
                        </div>
                    </div>

                    <!-- Login Button (if not logged in) -->
                    <router-link v-if="!showHeader" to="/Login" class="btn-pill btn-filled">
                        <span>الدخول</span>
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"/>
                        </svg>
                    </router-link>

                    <!-- Subscribe Button -->
                    <router-link to="/Trailer" class="btn-pill btn-outline">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"/>
                        </svg>
                        <span>الاشتراك</span>
                    </router-link>
                </div>

                <!-- Zain Logo -->
                <a href="https://sd.zain.com/" target="_blank" class="zain-logo-link">
                    <img src="https://nashoof.sd.zain.com/assets/img/logoSvg.svg" alt="Zain" class="zain-logo" />
                </a>
            </div>

            <!-- Mobile Menu Toggle -->
            <button class="mobile-toggle" @click="toggleMobileMenu">
                <span :class="{ 'active': mobileMenuOpen }"></span>
                <span :class="{ 'active': mobileMenuOpen }"></span>
                <span :class="{ 'active': mobileMenuOpen }"></span>
            </button>
        </div>

        <!-- Mobile Menu -->
        <transition name="slide-down">
            <div class="mobile-menu" v-show="mobileMenuOpen">
                <form @submit.prevent="SearchData()" class="mobile-search">
                    <input type="text" v-model="search" placeholder="بحث عن المحتوى..." />
                    <button type="submit">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
                        </svg>
                    </button>
                </form>
                <nav class="mobile-nav">
                    <router-link to="/" class="mobile-nav-item" @click="mobileMenuOpen = false">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/></svg>
                        <span>الرئيسية</span>
                    </router-link>
                    <router-link to="/Health" class="mobile-nav-item" @click="mobileMenuOpen = false">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M19 3H5c-1.1 0-1.99.9-1.99 2L3 19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 11h-4v4h-4v-4H6v-4h4V6h4v4h4v4z"/></svg>
                        <span>صحة</span>
                    </router-link>
                    <router-link to="/Education" class="mobile-nav-item" @click="mobileMenuOpen = false">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3L1 9l11 6 9-4.91V17h2V9L12 3z"/></svg>
                        <span>تعليم</span>
                    </router-link>
                    <router-link to="/Low" class="mobile-nav-item" @click="mobileMenuOpen = false">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M4 4h16v2H4zm0 14h16v2H4zm0-7h16v2H4z"/></svg>
                        <span>قانون</span>
                    </router-link>
                    <router-link to="/Art" class="mobile-nav-item" @click="mobileMenuOpen = false">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M18 4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4h-4z"/></svg>
                        <span>فن ودراما</span>
                    </router-link>
                    <router-link to="/Contact" class="mobile-nav-item" @click="mobileMenuOpen = false">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/></svg>
                        <span>اتصل بنا</span>
                    </router-link>
                    <router-link v-if="showHeader" to="/Profile" class="mobile-nav-item" @click="mobileMenuOpen = false">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/></svg>
                        <span>حسابي</span>
                    </router-link>
                </nav>
            </div>
        </transition>
    </header>
</template>

<script>
import { HTTP } from '@/Api/http-common';
import { HTTPDSP } from '@/Api/http-dsp';
import { useToast } from "vue-toastification";
import { useRoute } from 'vue-router';
import { computed } from 'vue';
import config from '@/Api/config';

export default {
    name: 'AppHeader',
    data() {
        return {
            categSaha: null,
            categEducation: null,
            categLow: null,
            categArt: null,
            search: "",
            showCategories: false,
            showUserMenu: false,
            mobileMenuOpen: false,
        };
    },

    watch: {
        '$route'() {
            this.showCategories = false;
            this.showUserMenu = false;
            this.mobileMenuOpen = false;
        }
    },

    setup() {
        const route = useRoute();
        const path = computed(() => route.path).value;
        if (path.includes(".php")) {
            this.$router.push("/");
            this.$router.go();
        }
    },

    beforeCreate: function () {
        if (this.$cookie.isCookieAvailable("mdn")) {
            HTTPDSP.get(
                "DSPCheckLogin.php?msisdn=" + this.$cookie.getCookie("mdn"),
                {
                    headers: {
                        'Authorization': config.authHeader,
                    },
                }
            ).then((response) => {
                if (response.data.status == 1) {
                    return;
                } else {
                    this.$cookie.removeCookie("mdn");
                    this.$cookie.removeCookie("Content_id");
                    this.$cookie.removeCookie("minutes");
                    this.$cookie.removeCookie("Catogery_id");
                    this.$cookie.removeCookie("product_code");
                }
            });
            this.showHeader = true;
        } else {
            this.showHeader = false;
        }
    },

    mounted() {
        if (this.$cookie.isCookieAvailable("mdn")) {
            const apiUrl = "DSPCheckLogin.php?msisdn=" + this.$cookie.getCookie("mdn");
            const headers = { headers: { 'Authorization': config.authHeader } };

            HTTPDSP.get(apiUrl, headers).then((response) => {
                this.categArt = response.data.status;
                this.$cookie.setCookie('Health', response.data.status, 60 * 300);
            });
            HTTPDSP.get(apiUrl, headers).then((response) => {
                this.categArt = response.data.status;
                this.$cookie.setCookie('EDU', response.data.status, 60 * 300);
            });
            HTTPDSP.get(apiUrl, headers).then((response) => {
                this.categArt = response.data.status;
                this.$cookie.setCookie('Law', response.data.status, 60 * 300);
            });
            HTTPDSP.get(apiUrl, headers).then((response) => {
                this.categArt = response.data.status;
                this.$cookie.setCookie('Drama', response.data.status, 60 * 300);
            });
        }
    },

    methods: {
        toggleMobileMenu() {
            this.mobileMenuOpen = !this.mobileMenuOpen;
        },
        unsubscribe: function () {
            let loader = this.$loading.show({
                container: this.oldNum ? null : this.$refs.formContainer,
            });
            setTimeout(() => loader.hide(), 5 * 1000);

            const toast = useToast();
            HTTPDSP.get("DSPUnsubscribe.php?msisdn=" + this.$cookie.getCookie("mdn"), {
                headers: {
                    'Authorization': config.authHeader,
                },
            }).then((response) => {
                if (response.data.status == 1) {
                    this.$cookie.removeCookie("Content_id");
                    this.$cookie.removeCookie("minutes");
                    this.$cookie.removeCookie("Catogery_id");
                    this.$cookie.removeCookie("product_code");

                    toast.success("لقد تم الغاء اشتراكك من نشوف", {
                        timeout: 5000
                    });

                    this.$router.push("/");
                    this.$router.go();
                } else {
                    toast.error("عفوا ليست لديك اشتراك في خدمة نشوف", {
                        timeout: 5000
                    });
                }
            });
            this.showUserMenu = false;
        },
        SearchData() {
            const toast = useToast();
            const validTextRegex = /^[A-Za-z\u0600-\u06FF\s]*$/;

            if (validTextRegex.test(this.search)) {
                this.$router.push({ name: "Search", params: { search: this.search } });
            } else {
                this.search = this.search.replace(/[^A-Za-z\u0600-\u06FF\s]/g, '');
                toast.info("لا يوجد نتائج للبحث");
            }
            this.mobileMenuOpen = false;
        }
    },
}
</script>

<style scoped>
/* Dropdown Overlay */
.dropdown-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 50;
    background: transparent;
}

/* Hero Header Base */
.hero-header {
    background: linear-gradient(180deg, #0d9488 0%, #0a7a70 50%, #065f58 100%);
    min-height: 80px;
    position: relative;
    overflow: visible;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.hero-container {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 24px;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    position: relative;
    z-index: 100;
}

/* Right Section (Logo + Geometric) */
.hero-right {
    display: flex;
    align-items: center;
    gap: 16px;
    flex-shrink: 0;
    position: relative;
}

.hero-logo img {
    height: 42px;
    width: auto;
    filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.15));
    transition: transform 0.3s ease;
}

.hero-logo:hover img {
    transform: scale(1.05);
}

.shape {
    position: absolute;
    background: rgba(45, 212, 191, 0.35);
    clip-path: polygon(25% 0%, 100% 0%, 75% 100%, 0% 100%);
}

.shape-1 {
    width: 55px;
    height: 70px;
    top: -15px;
    right: 0;
    background: rgba(45, 212, 191, 0.45);
}

.shape-2 {
    width: 45px;
    height: 55px;
    top: 5px;
    right: 40px;
    background: rgba(45, 212, 191, 0.35);
}

.shape-3 {
    width: 38px;
    height: 48px;
    top: 15px;
    right: 70px;
    background: rgba(45, 212, 191, 0.28);
}

.shape-4 {
    width: 32px;
    height: 42px;
    top: 0px;
    right: 95px;
    background: rgba(45, 212, 191, 0.2);
}

/* Center Section - Search */
.hero-center {
    flex: 1;
    max-width: 380px;
    display: flex;
    justify-content: center;
}

.search-container {
    display: flex;
    align-items: center;
    width: 100%;
    background: rgba(0, 35, 35, 0.6);
    border-radius: 50px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    overflow: hidden;
}

.search-input {
    flex: 1;
    padding: 12px 20px;
    background: transparent;
    border: none;
    outline: none;
    color: #fff;
    font-size: 14px;
    direction: rtl;
    text-align: right;
}

.search-input::placeholder {
    color: rgba(255, 255, 255, 0.45);
}

.search-btn {
    padding: 12px 16px;
    background: transparent;
    border: none;
    cursor: pointer;
    color: rgba(255, 255, 255, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
}

.search-btn:hover {
    color: #fff;
}

/* Left Section */
.hero-left {
    display: flex;
    align-items: center;
    gap: 16px;
    flex-shrink: 0;
}

/* Navigation */
.hero-nav {
    display: flex;
    align-items: center;
    gap: 8px;
}

.nav-pill {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 18px;
    background: rgba(255, 255, 255, 0.12);
    border: 1px solid rgba(255, 255, 255, 0.18);
    border-radius: 50px;
    color: #fff;
    font-size: 14px;
    font-weight: 500;
    text-decoration: none;
    cursor: pointer;
    transition: all 0.3s ease;
    white-space: nowrap;
}

.nav-pill:hover {
    background: rgba(255, 255, 255, 0.2);
    transform: translateY(-1px);
}

.nav-pill svg {
    flex-shrink: 0;
}

.chevron {
    transition: transform 0.3s ease;
    margin-right: -4px;
}

.chevron.rotate {
    transform: rotate(180deg);
}

/* Action Buttons */
.action-buttons {
    display: flex;
    align-items: center;
    gap: 10px;
}

.btn-pill {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 20px;
    border-radius: 50px;
    font-size: 14px;
    font-weight: 500;
    text-decoration: none;
    cursor: pointer;
    transition: all 0.3s ease;
    white-space: nowrap;
    border: 2px solid transparent;
}

.btn-filled {
    background: #fff;
    color: #0d9488;
    border-color: #fff;
}

.btn-filled:hover {
    background: #f0fdfa;
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
}

.btn-outline {
    background: transparent;
    color: #fff;
    border: 2px solid #fff;
}

.btn-outline:hover {
    background: rgba(255, 255, 255, 0.1);
    transform: translateY(-2px);
}

/* Dropdown */
.nav-dropdown {
    position: relative;
    z-index: 100;
}

.dropdown-menu-box {
    position: absolute;
    top: calc(100% + 10px);
    right: 0;
    min-width: 180px;
    padding: 10px;
    z-index: 9999;
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
}

.dropdown-link {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px 16px;
    color: #334155;
    font-size: 14px;
    font-weight: 500;
    text-decoration: none;
    border-radius: 10px;
    transition: all 0.2s ease;
    cursor: pointer;
    border: none;
    background: transparent;
    width: 100%;
    text-align: right;
}

.dropdown-link:hover {
    background: rgba(13, 148, 136, 0.1);
    color: #0d9488;
}

.unsub-link {
    color: #ef4444;
}

.unsub-link:hover {
    background: rgba(239, 68, 68, 0.1);
    color: #dc2626;
}

/* Zain Logo */
.zain-logo-link {
    display: flex;
    align-items: center;
}

.zain-logo {
    height: 30px;
    width: auto;
    filter: brightness(0) invert(1);
    transition: all 0.3s ease;
}

.zain-logo-link:hover .zain-logo {
    transform: scale(1.05);
    filter: brightness(0) invert(1) drop-shadow(0 0 8px rgba(255, 255, 255, 0.4));
}

/* Mobile Toggle */
.mobile-toggle {
    display: none;
    flex-direction: column;
    justify-content: center;
    gap: 5px;
    width: 40px;
    height: 40px;
    padding: 8px;
    background: rgba(255, 255, 255, 0.12);
    border: 1px solid rgba(255, 255, 255, 0.18);
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.3s ease;
}

.mobile-toggle:hover {
    background: rgba(255, 255, 255, 0.2);
}

.mobile-toggle span {
    display: block;
    width: 100%;
    height: 2px;
    background: #fff;
    border-radius: 2px;
    transition: all 0.3s ease;
}

.mobile-toggle span.active:nth-child(1) {
    transform: rotate(45deg) translate(5px, 5px);
}

.mobile-toggle span.active:nth-child(2) {
    opacity: 0;
}

.mobile-toggle span.active:nth-child(3) {
    transform: rotate(-45deg) translate(5px, -5px);
}

/* Mobile Menu */
.mobile-menu {
    position: absolute;
    top: 100%;
    left: 16px;
    right: 16px;
    padding: 20px;
    z-index: 1000;
    margin-top: 8px;
    background: linear-gradient(135deg, #0d9488 0%, #0f766e 50%, #115e59 100%);
    border: 1px solid rgba(255, 255, 255, 0.15);
    box-shadow: 0 15px 50px rgba(0, 0, 0, 0.25);
    border-radius: 16px;
}

.mobile-search {
    display: flex;
    margin-bottom: 16px;
    background: rgba(0, 35, 35, 0.5);
    border-radius: 50px;
    border: 1px solid rgba(255, 255, 255, 0.1);
}

.mobile-search input {
    flex: 1;
    padding: 12px 16px;
    background: transparent;
    border: none;
    outline: none;
    color: #fff;
    font-size: 14px;
    direction: rtl;
    text-align: right;
}

.mobile-search input::placeholder {
    color: rgba(255, 255, 255, 0.5);
}

.mobile-search button {
    padding: 12px 16px;
    background: transparent;
    border: none;
    color: rgba(255, 255, 255, 0.7);
    cursor: pointer;
}

.mobile-nav {
    display: flex;
    flex-direction: column;
    gap: 4px;
    direction: rtl;
    text-align: right;
}

.mobile-nav-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 14px 16px;
    color: #fff;
    font-size: 15px;
    font-weight: 500;
    text-decoration: none;
    border-radius: 12px;
    transition: all 0.2s ease;
    text-align: right;
    direction: rtl;
}

.mobile-nav-item svg {
    flex-shrink: 0;
    opacity: 0.9;
}

.mobile-nav-item:hover {
    background: rgba(255, 255, 255, 0.15);
}

/* Transitions */
.slide-down-enter-active,
.slide-down-leave-active {
    transition: all 0.3s ease;
}

.slide-down-enter-from,
.slide-down-leave-to {
    opacity: 0;
    transform: translateY(-20px);
}

/* Responsive */
@media (max-width: 1100px) {
    .hero-nav {
        display: none;
    }

    .action-buttons {
        display: none;
    }

    .mobile-toggle {
        display: flex;
    }

    .hero-center {
        flex: 1;
        max-width: 280px;
    }
}

@media (max-width: 768px) {
    .hero-container {
        padding: 0 16px;
    }

    .hero-center {
        display: none;
    }

    .hero-logo img {
        height: 36px;
    }

    .zain-logo {
        height: 26px;
    }
}

@media (max-width: 480px) {
    .hero-right {
        gap: 10px;
    }

    .hero-left {
        gap: 10px;
    }
}
</style>
